import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import Logo from "./Logo";
import NavBar from "./NavBar";
import { SITE, NAV } from "../data/content";

export default function Layout({ children }) {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="nn-page-bg min-h-screen w-full">
      <div className="max-w-[1140px] mx-auto bg-white shadow-[0_0_30px_rgba(0,0,0,0.08)] min-h-screen">
        {/* Header */}
        <header className="px-6 pt-6 pb-4">
          <div className="flex flex-col md:flex-row items-center md:items-stretch gap-6">
            <div className="flex-1 max-w-[420px]">
              <Logo />
            </div>
            <div className="hidden md:flex flex-1 items-center justify-end">
              <div className="nn-sage-box px-8 py-5 text-center">
                <p className="font-display italic text-xl leading-snug">{SITE.tagline1}</p>
                <p className="font-display italic text-xl leading-snug">{SITE.tagline2}</p>
              </div>
            </div>
          </div>
        </header>

        {/* Nav */}
        <NavBar />

        {/* Main */}
        <main className="px-6 py-8">{children}</main>

        {/* Footer */}
        <footer className="border-t border-[#d6dcb6] bg-[#f6f8ec] px-6 py-8 mt-8">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4">
            {NAV.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                className="text-sm font-display tracking-wide text-[#7d8e54] hover:text-[#5b6a37]"
              >
                {item.label}
              </Link>
            ))}
          </div>
          <div className="flex justify-center mb-3">
            <Logo className="w-[280px] opacity-80" />
          </div>
          <p className="text-center text-xs text-[#7d8e54]">
            © {new Date().getFullYear()} Nourish Natural Health Clinic, LLC. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
}
